import { render } from "./FirstPage.vue?vue&type=template&id=27cdee23"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"

import "./FirstPage.vue?vue&type=style&index=0&id=27cdee23&lang=css"

import exportComponent from "D:\\emad_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__